<template>
    <div>
        <el-form class="frame-form" ref="form" label-width="80px">
            <!-- data -->
            <div class="data">
                <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
                    <el-button v-for="item in types" type="info" plain @click="addSub(item.type)" v-html="item.title"></el-button>
                </div>
                <div class="elements">
                    <div class="element" v-for="(item, index) in instance.elements" :key="index">
                        <el-row :gutter="20">
                            <el-col :span="20" class="element-title">
                                <SubDetailElement :model="item" :type="item.type" :title="item.title" :sign="item.sign"></SubDetailElement>
                            </el-col>
                            <el-col :span="4" class="element-operator">
                                <el-button icon="el-icon-caret-top" circle @click="moveUpSub(index)"></el-button>
                                <el-button icon="el-icon-caret-bottom" circle @click="moveDownSub(index)"></el-button>
                                <el-button icon="el-icon-edit" circle @click="editSub(index)"></el-button>
                                <el-button icon="el-icon-delete" circle @click="delSub(index)"></el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <!-- attributes -->
            <el-tabs type="border-card" v-show="attributes.length>0">
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-suitcase-1"></i> 属性</span>
                    <div class="attribute" v-for="(component, index) in attributes" :key="index">
                        <component :is="component.type" v-model="attributes[index]"></component>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="actions">
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-form>
        <!-- component dialog -->
        <el-dialog title="组件编辑" :visible.sync="dialogVisible" width="60%" append-to-body>
            <component :key="componentId" @closeComponent="closeComponent" :is="element.type" v-model="element" :sign="element.sign"></component>
        </el-dialog>
    </div>
</template>
<script>
import SentenceSearch from './SentenceSearch.vue'
import elementMixin from '../mixins/graphic/element'
import subElementMixin from '../mixins/graphic/subElement'
import SubDetailElement from './SubDetailElement.vue'
import signMixin from '../mixins/graphic/sign'
import Label from './Label.vue'
import Translation from './Translation.vue'
import Sentence from './Sentence.vue'
import Grammar from './Grammar.vue'
import Struct from './Struct.vue'
import cloneMixin from '../mixins/graphic/clone'
export default {
    name: 'Frame',
    mixins: [elementMixin, signMixin, cloneMixin, subElementMixin],
    components: {
        PinyinPreview: require('@/components/PinyinPreview').default,
        PinyinInput: require('@/components/PinyinInput').default,
        SentenceSearch,
        SubDetailElement,
        Label,
        Sentence,
        Translation,
        Grammar,
        Struct,
    },
    data() {
        return {
            types: [
                { title: "语法", type: "Grammar" },
                { title: "结构", type: "Struct" },
                { title: "例句", type: "Sentence" },
                { title: "标记", type: "Label" },
                { title: "文本", type: "Translation" },
            ],
            default: {
                frame: {
                    elements: [],
                }
            },
            data: {
                frame: {
                    elements: [],
                },
            },
        }
    },
    methods: {
        initInstance() {
            this.instance = this.data.frame
        },
    }
}
</script>
<style lang="scss">
.attribute {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
        border-bottom: 0px;
    }
}

.actions {
    display: flex;
    margin-top: 20px;
    justify-content: center;
}

.elements {
    .element {
        background-color: #f5f5f5;
        box-shadow: 0px 2px 3px #ccc;
        border-radius: 10px;
        padding: 10px;
        margin: 10px 0px;
        color: #333;

        .element-title {
            height: 40px;
            line-height: 40px;
        }

        .element-operator {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .empty {
                border-color: red;
                color: red;
            }
        }
    }

    .element:hover {
        background-color: #f5f5f5;
    }
}
</style>